import { NetworkIdSchema } from "../network/network.js";
import z from "zod";
const AnnouncementBannerSchema = z.object({
  id: z.string(),
  networkId: NetworkIdSchema.optional(),
  title: z.string(),
  description: z.string(),
  primaryCta: z.object({
    url: z.string(),
    label: z.string()
  }).optional(),
  secondaryCta: z.object({
    url: z.string(),
    label: z.string()
  }).optional(),
  publishedAt: z.string().datetime(),
  imageUrl: z.string().url().optional(),
  backgroundColor: z.string().optional()
});
export {
  AnnouncementBannerSchema
};
//# sourceMappingURL=announcementBanner.js.map